export default {
  getPortKey: state => {
    return `${state.selectedPort.id}:${state.selectedPort.hash}`
  }
}